import {
  AppLayout,
  AppLayoutProps,
  Box,
  ColumnLayout,
  Container,
  ContentLayout,
  Grid,
  Header,
  Link,
  SpaceBetween,
  TextContent,
  Badge,
  Button,
  Cards,
} from "@cloudscape-design/components";
import { useEffect, useState, useContext } from "react";
import { GlobalContext, ContentContext } from "../../../context";
import { link } from "fs";

export default function DriversAndTeams() {
  const { 
    activeSeriesName, setActiveSeriesName
  } = useContext(GlobalContext);
  // const [activeHref, setActiveHref] = useState("/news");

  return (
    <>
      <Container header={<Header variant="h1"> {`${activeSeriesName} Teams`} </Header>}>
        <Cards
          ariaLabels={{
            itemSelectionLabel: (e, n) => `select ${n.name}`,
            selectionGroupLabel: "Item selection"
          }}
          cardDefinition={{
            sections: [
              {
                id: "description",
                header: "Driver",
                content: item => item.description
              },{
                id: "type",
                header: "Team",
                content: item => item.type
              },{
                id: "size",
                header: "Car Number",
                content: item => item.size
              },{
                id: "location",
                header: "Location",
                content: item => item.location
              },{
                id: "about",
                header: "About",
                content: item => item.about
              }
            ]
          }}
          cardsPerRow={[
            { cards: 1 },
            { minWidth: 500, cards: 3 }
          ]}
          items={[
            {
              name: "Item 1",
              alt: "First",
              description: "This is the first item",
              type: "1A",
              size: "Small",
              location: "Sydney/Australia",
              about: "This is the first item",
            },
            {
              name: "Item 2",
              alt: "Second",
              description: "This is the second item",
              type: "1B",
              size: "Large",
              location: "Sydney/Australia",
              about: "This is the first item",
            },
            {
              name: "Item 3",
              alt: "Third",
              description: "This is the third item",
              type: "1A",
              size: "Large",
              location: "Sydney/Australia",
              about: "This is the first item",
            },
            {
              name: "Item 4",
              alt: "Fourth",
              description: "This is the fourth item",
              type: "2A",
              size: "Small",
              location: "Sydney/Australia",
              about: "This is the first item",
            },
            {
              name: "Item 5",
              alt: "Fifth",
              description: "This is the fifth item",
              type: "2A",
              size: "Large",
              location: "Sydney/Australia",
              about: "This is the first item",
            },
            {
              name: "Item 6",
              alt: "Sixth",
              description: "This is the sixth item",
              type: "1A",
              size: "Small",
              location: "Sydney/Australia",
              about: "This is the first item",
            },
            {
              name: "Item 7",
              alt: "Seventh",
              description: "This is the seventh item",
              type: "1A",
              size: "Small",
              location: "Sydney/Australia",
              about: "This is the first item",
            },
            {
              name: "Item 8",
              alt: "Eighth",
              description: "This is the eighth item",
              type: "1A",
              size: "Small",
              location: "Sydney/Australia",
              about: "This is the first item",
            },
            {
              name: "Item 9",
              alt: "Nineth",
              description: "This is the nineth item",
              type: "1A",
              size: "Small",
              location: "Sydney/Australia",
              about: "This is the first item",
            }
          ]}
          loadingText="Loading resources"
          empty={
            <Box textAlign="center" color="inherit">
              <b>No resources</b>
              <Box
                padding={{ bottom: "s" }}
                variant="p"
                color="inherit"
              >
                No resources to display.
              </Box>
              <Button>Create resource</Button>
            </Box>
          }
        />
      </Container>
    </>
  );
}
